import { Button, ModalFooter } from '@ds';
import { BaseCaseResource, ResourceLogisticsStatus } from '@/api/apis/case';

type ViewResourceModalFooterProps = {
  resource?: BaseCaseResource | null;
  isLoading: boolean;
  isAssignEnabled: boolean;
  isRemoveEnabled: boolean;
  removeAllowedStatuses: ResourceLogisticsStatus[];
  onRemove: () => void;
  onAssign: () => void;
};

export const ViewResourceModalFooter = ({
  resource,
  isAssignEnabled,
  isRemoveEnabled,
  removeAllowedStatuses,
  isLoading,
  onAssign,
  onRemove,
}: ViewResourceModalFooterProps) => {
  const isRemoveAllowed = isRemoveEnabled && resource && removeAllowedStatuses.includes(resource.logisticsStatus);
  const isAssignAllowed = isAssignEnabled && resource && resource.logisticsStatus === ResourceLogisticsStatus.Reserved;
  const showFooter = isRemoveAllowed || isAssignAllowed;

  return showFooter ? (
    <ModalFooter className="flex gap-2 justify-end">
      {isRemoveAllowed && (
        <Button isDisabled={isLoading} size="md" color="default" variant="outline" onPress={onRemove}>
          Remove
        </Button>
      )}
      {isAssignAllowed && (
        <Button isDisabled={isLoading} size="md" color="default" variant="solid" onPress={onAssign}>
          Assign
        </Button>
      )}
    </ModalFooter>
  ) : null;
};
